"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFilters = TableFilters;
const react_1 = __importStar(require("react"));
const i18n_1 = require("@tcc/i18n");
const fds_1 = require("@tcc/fds");
const TableFilters_css_1 = require("./TableFilters.css");
const FiltersPopoverContent_1 = require("./FiltersPopoverContent");
var FilterVariant;
(function (FilterVariant) {
    FilterVariant["Text"] = "text";
    FilterVariant["Select"] = "select";
    FilterVariant["MultiSelect"] = "multi-select";
})(FilterVariant || (FilterVariant = {}));
function assertFilterMeta(meta, columnId) {
    if (!meta || typeof meta !== 'object') {
        throw new Error(`Column "${columnId}" is filterable but missing filter metadata`);
    }
    const typedMeta = meta;
    if (!('filterVariant' in typedMeta) || !('filterOptions' in typedMeta)) {
        throw new Error(`Column "${columnId}" filter metadata must include filterVariant and filterOptions`);
    }
}
function getMultiSelectFilterValues(filters) {
    return filters.reduce((acc, filter) => {
        if (Array.isArray(filter.value)) {
            acc[filter.id] = filter.value;
        }
        return acc;
    }, {});
}
function isColumnFilterable(column) {
    if (!column.getCanFilter())
        return false;
    const { meta } = column.columnDef;
    if (!meta)
        return false;
    const typedMeta = meta;
    return (typedMeta.filterVariant === FilterVariant.Select ||
        typedMeta.filterVariant === FilterVariant.MultiSelect);
}
function mapColumnToFilterableColumn(column) {
    const { meta, header } = column.columnDef;
    assertFilterMeta(meta, column.id);
    return {
        id: column.id,
        label: typeof header === 'string' ? header : column.id,
        filterVariant: meta.filterVariant,
        options: meta.filterOptions,
    };
}
function TableFilters({ table, prefixTestId = 'filters', isLoading = false, buttonLabel, headerTitle, }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [tempFilters, setTempFilters] = (0, react_1.useState)({});
    const defaultButtonLabel = (0, i18n_1.getMessage)('table.filters');
    const defaultHeaderTitle = (0, i18n_1.getMessage)('table.filters.title');
    const finalButtonLabel = buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : defaultButtonLabel;
    const finalHeaderTitle = headerTitle !== null && headerTitle !== void 0 ? headerTitle : defaultHeaderTitle;
    const columns = table.getAllLeafColumns();
    const filterableColumns = (0, react_1.useMemo)(() => columns.filter(isColumnFilterable).map(mapColumnToFilterableColumn), [columns]);
    const { columnFilters } = table.getState();
    const currentFilters = (0, react_1.useMemo)(() => getMultiSelectFilterValues(columnFilters), [columnFilters]);
    const activeFilterCount = (0, react_1.useMemo)(() => columnFilters.length, [columnFilters]);
    const filtersLabel = (0, react_1.useMemo)(() => {
        if (activeFilterCount > 0) {
            return `${finalButtonLabel} (${activeFilterCount})`;
        }
        return finalButtonLabel;
    }, [activeFilterCount, finalButtonLabel]);
    const handleOpenChange = (0, react_1.useCallback)((isOpen) => {
        if (isOpen) {
            setTempFilters(currentFilters);
        }
        setOpen(isOpen);
    }, [currentFilters]);
    const handleApply = (0, react_1.useCallback)(() => {
        const newFilters = Object.entries(tempFilters)
            .filter(([_, value]) => {
            if (Array.isArray(value))
                return value.length > 0;
            return value !== undefined && value !== '';
        })
            .map(([id, value]) => ({ id, value }));
        table.setColumnFilters(newFilters);
        setOpen(false);
    }, [table, tempFilters]);
    const handleCancel = (0, react_1.useCallback)(() => {
        setTempFilters(currentFilters);
        setOpen(false);
    }, [currentFilters]);
    const handleClearAll = (0, react_1.useCallback)(() => {
        setTempFilters({});
        table.resetColumnFilters();
        setOpen(false);
    }, [table]);
    const handleToggleOption = (0, react_1.useCallback)((columnId, optionValue) => {
        setTempFilters((prev) => {
            const currentValues = prev[columnId] || [];
            const newValues = currentValues.includes(optionValue)
                ? currentValues.filter((v) => v !== optionValue)
                : [...currentValues, optionValue];
            return Object.assign(Object.assign({}, prev), { [columnId]: newValues });
        });
    }, []);
    const handleSelectAll = (0, react_1.useCallback)((columnId, allValues) => {
        setTempFilters((prev) => {
            const currentValues = prev[columnId] || [];
            const allSelected = allValues.every((v) => currentValues.includes(v));
            return Object.assign(Object.assign({}, prev), { [columnId]: allSelected ? [] : allValues });
        });
    }, []);
    const trigger = (react_1.default.createElement(fds_1.Button, { testId: `${prefixTestId}-toggle-button`, fill: fds_1.ButtonFill.Ghost, color: fds_1.ComponentColor.Neutral, size: fds_1.ComponentSize.Sm },
        react_1.default.createElement(fds_1.Icon, { icon: fds_1.FdsIcon.FilterList, variation: fds_1.IconVariation.Filled }),
        filtersLabel));
    return (react_1.default.createElement(fds_1.Popover, { testId: `${prefixTestId}-toggle-menu`, open: open, onChange: handleOpenChange, contentProps: {
            align: fds_1.ElementAlign.Start,
            side: fds_1.ElementSide.Bottom,
            className: TableFilters_css_1.filtersPopover,
        }, trigger: trigger },
        react_1.default.createElement(FiltersPopoverContent_1.FiltersPopoverContent, { isLoading: isLoading, filterableColumns: filterableColumns, tempFilters: tempFilters, prefixTestId: prefixTestId, headerTitle: finalHeaderTitle, onToggleOption: handleToggleOption, onSelectAll: handleSelectAll, onCancel: handleCancel, onClearAll: handleClearAll, onApply: handleApply })));
}
